@if (isVisible()) {
  <div class="migration-banner" [class.migration-banner--paid]="tier() === 'paid'" role="alert" aria-live="polite">

    <!-- Left: sparkle icon -->
    <div class="migration-banner__icon" aria-hidden="true">
      ✦
    </div>

    <!-- Center: copy -->
    <div class="migration-banner__body">
      <p class="migration-banner__headline" [innerHTML]="headline()"></p>
      <p class="migration-banner__subtext">{{ subtext() }}</p>
    </div>

    <!-- Right: CTA + dismiss -->
    <div class="migration-banner__actions">
      <button
        nz-button
        nzType="primary"
        class="migration-banner__cta"
        [nzLoading]="isLoadingRedirect()"
        (click)="goToN3()"
        aria-label="Go to N3 AI Accounting">
        {{ ctaLabel() }}
      </button>
    </div>

  </div>
}
